<script>
    import BranchPath from '../../../Branch/BranchPath.svelte';
    export let row = null;
</script>

<style>

</style>

<BranchPath path={row.branch.full_name}/>